import {Card, CardActionArea, CardContent, Grid, Typography,} from "@mui/material"
import {Box} from "@mui/system"

/**
 Required props are:
 - contract: This is the data to be displayed
 - notesMode: This is actual page you are implementing this from.
 */

export default function MeterChargesCard(props) {
    return (
        <Grid
            container
            sx={{
                display: "flex",
                flexDirection: "column",
                width: { xs: "100%", lg: "50%" },
                height: {xs: "100%", lg: props.height ? props.height : "500px"},
                maxHeight: {xs: "100%", lg: props.height ? props.height : "500px"},
                backgroundColor: "#fff",
                borderRadius: "10px",
                margin: "20px auto",
                padding: 0,
                boxShadow: "0 4px 12px 0 rgba(0,0,0,0.25)",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    flexWrap: "nowrap",
                    width: "100%",
                    padding: "20px",
                }}
            >
                <Typography
                    sx={{
                        fontWeight: "bold",
                        marginBottom: "10px",
                        fontSize: "18px",
                        color: "#037171",
                    }}
                >
                    Meter Charges
                </Typography>
            </Box>

            <Box
                sx={{
                    backgroundColor: "#EFEFEF",
                    borderRadius: "10px",
                    flex: 1,
                    width: "100%",
                    padding: "10px",
                    margin: "5px 0 0 0",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    minHeight: 0, // This is crucial for flex children to shrink properly
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        flexWrap: "nowrap",
                        width: "100%",
                        padding: "5px",
                        backgroundColor: "#efefef",
                        overflowY: "auto",
                        overflowX: "hidden",
                    }}
                >
                    {props.contract && props.contract.billingChargeItems.length < 1 && (
                        <Typography
                            sx={{
                                color: "#C6C5C5",
                                fontSize: "11px",
                                fontWeight: 700,
                                width: "100%",
                                textAlign: "center",
                            }}
                        >
                            There are no Meter Charges
                        </Typography>
                    )}
                    {props.contract &&
                        props.contract.billingChargeItems.length > 0 &&
                        props.contract.billingChargeItems.map(function (billItem, i) {
                            return (
                                <Card key={i} sx={{width: "95%", margin: "8px 0", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", flex: "0 0 auto"}}>
                                    <CardActionArea>
                                        <CardContent sx={{padding: "12px"}}>
                                            <Box sx={{display: "flex", flexDirection: "column", gap: "8px"}}>
                                                {/* Meter Name */}
                                                <Typography 
                                                    variant="body2" 
                                                    sx={{ 
                                                        fontWeight: 600, 
                                                        color: "#037171",
                                                        fontSize: "0.85rem",
                                                        lineHeight: 1.3,
                                                        wordBreak: "break-word"
                                                    }}
                                                >
                                                    {billItem.meter.name}
                                                </Typography>
                                                
                                                {/* Charge and Amount Row */}
                                                <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                                    <Typography 
                                                        variant="body2" 
                                                        sx={{ 
                                                            color: "#666",
                                                            fontSize: "0.8rem",
                                                            flex: 1,
                                                            marginRight: "12px"
                                                        }}
                                                    >
                                                        {billItem.charge.name}
                                                    </Typography>
                                                    <Typography 
                                                        variant="body2" 
                                                        sx={{ 
                                                            fontWeight: 700, 
                                                            color: "#037171",
                                                            fontSize: "0.9rem",
                                                            textAlign: "right",
                                                            minWidth: "fit-content"
                                                        }}
                                                    >
                                                        {billItem.total}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            )
                        }, this)}
                </Box>
            </Box>
        </Grid>
    )
}
